module.exports = __webpack_public_path__ + "assets/phone-icon-red.1e574328.svg";